export default __webpack_public_path__ + "static/media/modal-banner.c6845dbd.jpg";